import { axios } from '../../../lib/axios';

function toQueryString(params = {}) {
  return Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
}

export const listRegistryRequests = (query = {}) => {
  if (!query?.orgId) throw new Error('orgId is required to list registry requests');
  return axios.get(`family-practice-registry?${toQueryString(query)}`);
};

export const getRegistryRequestById = (id) => {
  if (!id) throw new Error('id is required');
  return axios.get(`family-practice-registry/${encodeURIComponent(id)}`);
};

export const updateRegistryRequest = (id, patch = {}) => {
  if (!id) throw new Error('id is required');
  return axios.put(`family-practice-registry/${encodeURIComponent(id)}`, patch);
};
